import { useGetAccessToken } from "../hooks/useGetAccessToken";
import { useGetCases } from "../hooks/cases/useGetCases";
import { ExpertPortalAuthenticationTemplate } from "../components/AuthenticationTemplate/AuthenticationTemplate";
import { CasesContainer } from "../components/Cases/CasesContainer";

export const DischargeReportsDuePage = () => {
  const accessToken = useGetAccessToken();
  const cases = useGetCases(accessToken);
  return (
    <ExpertPortalAuthenticationTemplate>
      {cases && <CasesContainer cases={cases} />}
    </ExpertPortalAuthenticationTemplate>
  );
}
